/**
 * Narwhalia backend
 * Swagger API docs for Narwhalia Backend application
 *
 * OpenAPI spec version: 0.9
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MaxNarwhalProperties } from './maxNarwhalProperties'
import { ListResultDto } from './listResultDto'
import { InventoryItemDto } from './inventoryItemDto'
import { NarwhalDto } from './narwhalDto'
export { NarwhalDto } from './narwhalDto'
export { MaxNarwhalProperties } from './maxNarwhalProperties'

export interface NarwhalListResultDto extends ListResultDto<NarwhalDto> {
	/** Inventory items of the logged in user */
	inventoryItems?: Array<InventoryItemDto>;
	max: MaxNarwhalProperties;
}